<script setup>
// No inbox connected (phase 4.2, D-G5): the kit's Empty over faded kit InboxCards with neutral examples.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import InboxCard from 'dashboard/components-next/polaris/cards/InboxCard.vue';
import PolarisEmptyState from './PolarisEmptyState.vue';

const emit = defineEmits(['click']);

const { t, tm, rt } = useI18n();

const CHANNELS = ['Channel::WebWidget', 'Channel::Whatsapp', 'Channel::Email'];
const examples = computed(() =>
  tm('POLARIS.PAGES.EXAMPLES.INBOXES').map((example, index) => ({
    name: rt(example.NAME),
    identifier: rt(example.IDENTIFIER),
    channel: CHANNELS[index] ?? CHANNELS[0],
  }))
);
</script>

<template>
  <PolarisEmptyState
    :title="t('POLARIS.INBOXES.EMPTY_STATE.TITLE')"
    :description="t('POLARIS.INBOXES.EMPTY_STATE.SUBTITLE')"
    :action-label="t('POLARIS.INBOXES.ADD_NEW')"
    :action-perms="['administrator']"
    @click="emit('click')"
  >
    <template #backdrop>
      <InboxCard
        v-for="example in examples"
        :key="example.name"
        v-bind="example"
      />
    </template>
  </PolarisEmptyState>
</template>
